import React, { Component } from 'react';
import {
    Link
} from "react-router-dom";

//                       <Link to={this.props.tolink} className="navitemlink" onClick={this.props.activec.bind(this,this.props.item)}>{this.props.item}</Link>
class Navitem extends Component {
    render() {
                return (
                    <li id={this.props.item} className={this.props.className}>
                      <a href={this.props.tolink} className="navitemlink" onClick={this.props.activec}>{this.props.item}</a>
                    </li>
                    )
            }
        }

        export default Navitem
